import type { Ref } from 'react';
import React, { forwardRef, useCallback } from 'react';
import { type LayoutChangeEvent, type Text } from 'react-native';
import { StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';

import { BodyText } from '../../Text';
import type { TabNavTextProps } from '../TabNav.types';

export const TabText = forwardRef((props: TabNavTextProps, ref: Ref<Text>) => {
  const { children, active, onChangeMeasures } = props;

  const handleOnLayout = useCallback(
    (event: LayoutChangeEvent) => {
      onChangeMeasures?.({
        width: event.nativeEvent.layout.width,
        height: event.nativeEvent.layout.height,
        x: event.nativeEvent.layout.x,
        y: event.nativeEvent.layout.y,
      });
    },
    [onChangeMeasures],
  );

  return (
    <BodyText
      sizeMatch={['16']}
      onLayout={handleOnLayout}
      ref={ref}
      style={active ? styles.active : styles.inactive}
    >
      {children}
    </BodyText>
  );
});

const styles = StyleSheet.create({
  active: { color: theme.colors.KALE },
  inactive: { color: theme.colors.OPACITY.DARK_KALE.DARKER },
});
